
import Vue from "vue";
import { WfNotification } from "../classes/notification";
export default Vue.extend({
	data() {
		return {
			timeout: 0
		};
	},
	props: {
		value: {
			type: Object as () => WfNotification,
			required: true
		}
	},
	methods: {
		dismiss() {
			clearTimeout(this.timeout);
			this.$emit("dismiss");
		}
	},
	async mounted() {
		this.timeout = setTimeout(() => {
			this.dismiss();
		}, this.value.duration);
	}
});
